;(function() {
  const params = new URLSearchParams(window.location.search)
  const hasAvailability = params.has('filter.v.availability')
  const isCollection = window.location.pathname.includes('/collections/')
  
  if (isCollection && !hasAvailability) {
    params.set('filter.v.availability', '1')
    window.location.replace(window.location.pathname + '?' + params.toString())
  }
})()

; (function () {
  document.addEventListener('DOMContentLoaded', function () {

    const $$el = selector => document.querySelectorAll(selector)
    const $el = selector => document.querySelector(selector)

    function handleFilters() {
      const params = new URLSearchParams(window.location.search)
      const activeAvaibility = params.get('filter.v.availability')
      const elem = document.querySelector('[data-collection-filters]')
      let isCustomFilter = false

      // Prevent open drawer when click on custom filter button
      const observer = new MutationObserver(mutationsList => {
        for (let mutation of mutationsList) {
          if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'class' &&
            elem.classList.contains('collection__filters--visible') &&
            isCustomFilter
          ) {
            elem.classList.remove('collection__filters--visible')
          }
        }
      })

      observer.observe(elem, { attributes: true, attributeFilter: ['class'] })

      // Prevent mobile touch scroll lock when click on custom filter button
      const lockTouchObserver = new MutationObserver(mutationsList => {
        for (let mutation of mutationsList) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'data-scroll-locked') {
            if (document.documentElement.hasAttribute('data-scroll-locked')) {
              document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }))
            }
          }
        }
      })

      lockTouchObserver.observe(document.documentElement, { attributes: true })

      if (activeAvaibility !== '1') {
        $el('#crs_in_stock_switch').checked = false
      }

      $el('#crs_in_stock_switch').addEventListener('change', event => {
        isCustomFilter = true
        $el('.sticky-filters').classList.add('isSticky')
        $$el('input[name="filter.v.availability"]').forEach(input => {
          if (input.checked) {
            input.click()
          }
          if (event.target.checked) {
            if (input.id === 'filter-Availability-1') {
              input.click()
            }
          }
        })
      })

      scrollToActiveElement()

      $el('.collection__filters__toggle').addEventListener('click', () => {
        isCustomFilter = false

        $el('.collection__filters').classList.add('collection__filters--visible')

        document.body.classList.remove('scrolable')
      })
    }

    function scrollToActiveElement() {
      requestAnimationFrame(() => {
        $el('.sticky-filters').scrollLeft = 0
        $$el('.sticky-filters__btn').forEach((btn, index) => {
          if (btn.classList.contains('sticky-filters__btn--active')) {
            const scrollTarget = btn.offsetLeft + (btn.offsetWidth / 2) - ($el('.sticky-filters').clientWidth / 2)
            $el('.sticky-filters').scrollLeft = scrollTarget
          }
        })

        const categories = $$el('.subcategory__item')
        if (!categories || categories.length === 0) return
        categories.forEach((item, index) => {
          if (item.classList.contains('subcategory__item--active')) {
            const scrollTarget = item.offsetLeft + (item.offsetWidth / 2) - ($el('.subcategory').clientWidth / 2)
            $el('.subcategory').scrollLeft = scrollTarget
          }
        })
      })
    }

    function subcategoryHandler() {
      scrollToActiveElement()
      handleFilters()
    }

    subcategoryHandler()
  })
})()
